import { enableKeyIsValid } from "../eval";
import { Payment, PaymentLookup } from "../survey";

/**
 * Validates Payment components have all required fields.
 * PaymentLookup components are skipped as they have a different structure.
 */
export const paymentRequiredFieldsRule = (component: Readonly<Payment | PaymentLookup>) => {
  // PaymentLookup has a 'prop' field - skip validation for lookups
  if ('prop' in component) {
    return { passed: true };
  }

  // Skip validation if the enableKey is not valid
  // Valid here means that it isn't valid based on the typical enable key generation logic AND it isn't equal to 'true'
  // The 'true' check here is needed because of how payment_required_fields_rule.test.ts handles the enable key
  if (!enableKeyIsValid(component.enableKey, component) && component.enableKey !== 'true') {
    return { passed: true };
  }

  if (!component.name?.trim()) {
    return {
      passed: false,
      message: 'Payment is missing a group name'
    };
  }

  if (!component.type?.trim()) {
    return {
      passed: false,
      message: `Payment "${component.name}" is missing a type`
    };
  }

  if (!component.targetField?.trim()) {
    return {
      passed: false,
      message: `Payment "${component.name}" is missing a target field`
    };
  }

  if (!component.amount?.trim()) {
    return {
      passed: false,
      message: `Payment "${component.name}" is missing an amount`
    };
  }

  return { passed: true };
}
